import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, logout } from "../firebase";
import Button from "@mui/material/Button";
import { Avatar } from "@mui/material";
import "./HeaderNav.css";
import { NavButton } from "./NavButton";

const HeaderNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, loading, error] = useAuthState(auth);
  return (
    <>
      <div className="header__nav">
        <div className="header__block">
          <img src="scc.png" style={{ width: "100px" }} />
        </div>
        <div className="header__block useremail">
          <Avatar className="header__avatar" alt={user.email} src="/static/images/avatar/1.jpg" />
          {user.email}
        </div>
        <div className="header__block">
          {location.pathname === "/dashboard" ? (
            <NavButton
              text="New Applicant"
              action={() => {
                navigate("/newapp");
              }}
            />
          ) : (
            <NavButton
              text="Dashboard"
              action={() => {
                navigate("/dashboard");
              }}
            />
          )}
          <NavButton
            text="View Spreadsheet"
            link={
              <a
                className="header__hyper"
                href="https://docs.google.com/spreadsheets/d/1Umdp3DX67iuQ5R1hsMVy54nObcY1sDukIawrEnoxn5I/edit?usp=sharing"
                target="_blank"
              >
                VIEW SPREADSHEET
              </a>
            }
            action={() => {
              console.log("opening spreadsheer");
            }}
          />

          <div
            className="header__link"
            onClick={async () => {
              try {
                logout();
              } catch (e) {
                alert(e.message);
              }
            }}
          >
            Log Out
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderNav;
